import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./InspirationalGalleryDetails.module.css";
import { SearchInput, SubmitButton, TextComponent } from "../../../components";
import { Carousel, List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { InspirationalGalleryMiddleware } from "../../../Store/Middlewares/InspirationalGalleryMiddleware";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import "./IGoverride.css";
import IGImageDetails from "../IGImageDetails/IGImageDetails";
import {
  BiLeftArrow,
  BiSolidLeftArrowAlt,
  BiSolidRightArrow,
} from "react-icons/bi";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Modal from "../../../components/modal/Modal";

const InspirationalGalleryDetails = () => {
  const [search, setsearch] = useState();
  const [deleteImgModal, setDeleteImgModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const timeout = useRef(null);
  const { state } = useLocation();
  const Gallery = useSelector(
    (state) => state.InspirationalGalleryReducer.categoryImages
  ); // use only for category photos
  const navigation = useNavigate();
  const dispatch = useDispatch();
  console.log("state", state);
  const role = Storage.getERole("@role");
  useEffect(() => {
    role == roles.client || role == roles.coHost
      ? getClientGalleryDetail()
      : getVendorGalleryDetail();
  }, []);
  const getClientGalleryDetail = () => {
    let data = {
      id: state?.item?.category_id,
      image_name: undefined,
      event_id: state?.event_id,
    };
    dispatch(InspirationalGalleryMiddleware.getClientGalleryByCategory(data));
  };
  const getVendorGalleryDetail = () => {
    setsearch(null);
    let data = {
      id: state?.item?.category_id,
      event_id: state?.event_id,
      image_name: undefined,
    };
    dispatch(InspirationalGalleryMiddleware.getVendorGalleryByCategory(data));
  };
  const onSearchEachImage = (e) => {
    let data = {
      id: state?.item?.category_id,
      image_name: e.target.value,
      event_id: state?.event_id,
    };
    setsearch(e.target.value);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      if (role == roles?.vendor) {
        dispatch(
          InspirationalGalleryMiddleware.getVendorGalleryByCategory(data)
        );
      } else {
        dispatch(
          InspirationalGalleryMiddleware.getClientGalleryByCategory(data)
        );
      }
    }, 1000);
  };

  const onPressDlt = () => {
    dispatch(InspirationalGalleryMiddleware.deleteGalleryByID(deleteId))
      .then((data) => {
        if (data?.length > 0) {
          setDeleteImgModal(false);
          setDeleteId(null);
        } else {
          navigation(-1);
        }
        // navigation(-1);
      })
      .catch(() => {});
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.header}>
        <TextComponent
          text={state?.item?.category_name}
          textClass={styles.headTxt}
        />
        {(role === roles.client || role === roles.coHost) && (
          <SubmitButton
            title={"Add Images"}
            btnClass={styles.addImgBtn}
            onClick={() =>
              navigation("/events/createInspirationalGallery", {
                state: {
                  headrTitle: "Inspirational Gallery",
                  event_id: state?.event_id,
                  category: state?.item,
                },
              })
            }
          />
        )}
        {/* <SearchInput
          className={styles.search}
          placeholder={"Search"}
          value={search}
          onChange={(e) => onSearchEachImage(e)}
        /> */}
      </div>
      {/* <List
        className={styles.list}
        grid={{ xxl: 3, xl: 3, lg: 2, xs: 1, md: 2 }}
        itemLayout="horizontal"
        dataSource={Gallery}
        renderItem={renderCategory}
      /> */}
      <Carousel
        className={`${styles.Carousel} caroselOverride`}
        // autoplay
        dots={{ className: "dotsCarosel" }}
        nextArrow={<BsChevronRight size={40} color="var(--primary-color)" />}
        prevArrow={<BsChevronLeft size={40} color="var(--primary-color)" />}
        arrows
        infinite={true}
      >
        {Gallery?.map((item, i) => (
          <IGImageDetails
            key={item.id}
            item={item}
            setDeleteImgModal={setDeleteImgModal}
            setDeleteId={setDeleteId}
          />
        ))}
      </Carousel>
      <Modal
        isModalOpen={deleteImgModal}
        setIsModalOpen={setDeleteImgModal}
        closable={true}
        className={styles.deleteImgModal}
        pinkBg={true}
      >
        <div className={styles.modalDiv}>
          <svg
            viewBox="0 0 196 187"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M137.284 178.874C137.284 183.044 140.664 186.434 144.844 186.434H175.064C179.234 186.434 182.624 183.054 182.624 178.874V133.544H137.294V178.874H137.284ZM186.394 122.204H173.174L169.394 118.424H150.504L146.724 122.204H133.504V129.764H186.394V122.204Z"
              fill="var(--primary-color)"
            />
            <path
              d="M194.812 114.634C191.352 112.084 188.112 109.834 185.062 107.354C184.082 106.554 182.912 105.074 183.022 104.034C183.412 100.404 181.482 98.2744 179.192 95.9444C170.932 87.5544 162.842 78.9944 154.332 70.1144C152.082 72.2144 150.642 73.4744 149.282 74.8244C125.042 98.9444 100.802 123.074 76.5622 147.194C70.9322 152.794 68.5122 152.844 62.9422 147.194C54.2122 138.334 45.5722 129.394 36.1822 119.754C28.1522 127.924 20.7322 135.424 13.4122 143.014C12.8322 143.614 12.7122 144.834 12.7122 145.764C12.6622 154.884 12.6822 163.994 12.6822 173.694C46.2022 173.694 79.4622 173.694 113.012 173.694C113.012 178.004 113.012 181.734 113.012 186.014C111.262 186.094 109.512 186.234 107.762 186.234C77.0522 186.244 46.3422 186.254 15.6322 186.234C4.50219 186.224 0.232188 182.114 0.222188 170.924C0.192188 118.794 0.222187 66.6744 0.312188 14.5444C0.312188 4.66441 4.72219 0.214414 14.6222 0.194414C70.0722 0.134414 125.512 0.134414 180.962 0.194414C190.302 0.204414 195.012 4.41441 195.052 13.1744C195.202 46.5444 195.142 79.9044 195.142 113.274C195.132 113.724 194.922 114.174 194.812 114.634ZM55.9222 66.3844C65.1522 66.4744 72.6122 59.0344 72.6522 49.6844C72.6922 40.6344 65.4222 33.2144 56.3622 33.0644C47.0022 32.9044 39.5222 40.1644 39.4322 49.4944C39.3422 58.9244 46.5322 66.2944 55.9222 66.3844Z"
              fill="var(--primary-color)"
            />
          </svg>
          <div className={styles.modalTxtDiv}>
            <TextComponent
              text={"Do you want to Delete"}
              textClass={styles.modalTxt}
            />
            <TextComponent text={"Image"} textClass={styles.modalSubTxt} />
          </div>
          <SubmitButton
            title={"Delete"}
            btnClass={styles.modalBtn}
            onClick={() => onPressDlt()}
          />
          <SubmitButton
            outline
            title={"Cancel"}
            btnClass={styles.modalBtn}
            onClick={() => setDeleteImgModal(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

const RenderCategory = ({ item, index }) => {
  const navigation = useNavigate();
  const { state } = useLocation();

  return (
    <div className={styles.square}>
      <img src={item?.image} className={styles.listImg} />
      <TextComponent text={item?.name} textClass={styles.ItemName} />
    </div>
  );
};

export default InspirationalGalleryDetails;
